export const serverApi = 'https://api.innerlogic.com'
//
export const staginApi = 'https://stg-django-api.innerlogic-api.com'
export const stagingApi = 'https://stg-django-api.innerlogic-api.com'
//
export const chatGPTNodeApi = "https://survey-chat-v2.innerlogic-api.com"
export const chatGPTNodeApiStg = "https://stg-survey-chat-v2.innerlogic-api.com"
// Publishable key
// export const currentApi = serverApi
export const currentApi = stagingApi

export const chatGptApi = chatGPTNodeApiStg
// export const chatGptApi = chatGPTNodeApi  

export const Environment = 'Development'

export const SentryDSN_DEV = "" 
export const SentryDSN_PROD = "https://b353fc5849e94e14be0255bb24eff1fb@o1167548.ingest.sentry.io/6258731"
export const SentryDSN_STG = "https://77a3a75262414b558301b2aeb57c7b3b@o1167548.ingest.sentry.io/6258797"

export const config = {
    loginapi: `${currentApi}/api/account`,
    authapi: `${currentApi}/api/rest-auth`,
    surveyapi: `${currentApi}/api/survey`,
    appapi: `${currentApi}/api/organization`,
    chatgptNode: `${chatGptApi}`,
    website: `${currentApi}/api/web`,
};

export default config

